import { render, staticRenderFns } from "./editorchannel.vue?vue&type=template&id=5130a080&scoped=true"
import script from "./editorchannel.vue?vue&type=script&lang=js"
export * from "./editorchannel.vue?vue&type=script&lang=js"
import style0 from "./editorchannel.vue?vue&type=style&index=0&id=5130a080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5130a080",
  null
  
)

export default component.exports